import { render, staticRenderFns } from "./OrderDetailSheet.vue?vue&type=template&id=5e61fdda&"
import script from "./OrderDetailSheet.vue?vue&type=script&lang=js&"
export * from "./OrderDetailSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports